"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Montessori() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="5198" id="legacy-of-dr-maria-montessori" className="dark bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="flex flex-col md:flex-row min-h-[600px]">
        {}
        <div className="hidden md:block md:w-[15%] shrink-0" aria-hidden="true" />

        {}
        <div ref={ref} className={`w-full md:w-[85%] bg-card text-card-foreground transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
          <div className="grid grid-cols-1 md:grid-cols-12 min-h-[600px] relative">
            {}
            <div className="md:col-span-5 relative overflow-hidden">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722029/img/maria_montessori_portrait.png" alt="Dr. Maria Montessori in her classroom" loading="lazy" decoding="async" className="w-full h-full min-h-[400px] md:min-h-full object-cover" />
            </div>

            {}
            <div className="md:col-span-7 relative px-8 py-12 md:px-14 md:py-20 lg:px-20 lg:py-24 flex flex-col justify-center">
              {}
              <p className="font-default text-xs md:text-sm tracking-[0.15em] text-primary mb-10 md:mb-14 uppercase">
                N°.05 &mdash; Our Guiding Philosophy
              </p>

              {}
              <blockquote className="font-default text-[2rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[3.5rem] leading-[1.1] tracking-tighter text-foreground mb-10 md:mb-14">
                <span>The child is the </span>
                <span className="font-serif italic">teacher</span>
                <span>. We are merely </span>
                <br className="hidden md:block" />
                <span className="font-serif italic">guides</span>
                <span> </span>
                <br className="hidden md:block" />
                <span>on their journey of </span>
                <br className="hidden md:block" />
                <span>discovery and growth.</span>
              </blockquote>

              {}
              <div className="space-y-5 max-w-xl mb-12 md:mb-16">
                <p className="font-default text-sm md:text-base leading-relaxed text-foreground">
                  Little Acorns Montessori School draws its inspiration from the scientific observations of Dr. Maria Montessori. We believe that every child possesses an innate desire to learn, and our environment is carefully prepared to nurture that natural curiosity.
                </p>
                <p className="font-default text-sm md:text-base leading-relaxed text-muted-foreground">
                  Since 2005, our educators have honored the individual pace of each student. Montessori education is not just a curriculum &mdash; it is a respectful partnership between the child, the prepared environment, and the community.
                </p>
              </div>

              {}
              <div>
                <Link to="/PhilosophyPage" className="inline-flex items-center gap-3 font-default text-xs md:text-sm tracking-[0.15em] uppercase text-foreground border-b border-foreground pb-1 hover:gap-4 transition-all duration-300">
                  Read Our Philosophy
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>

              {}
              <div className="absolute bottom-8 right-8 md:bottom-10 md:right-10 lg:bottom-12 lg:right-12">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-accent text-accent-foreground rounded-lg shadow-md">
                  <span className="font-default text-lg md:text-xl tracking-tight leading-none">
                    
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}